import {FC, useCallback} from 'react';
import {Form, Formik} from 'formik';
import {useNavigate} from 'react-router';
import {Col, Row} from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import {FormPageFooter, FormPageHeader} from "@components/falcon/common/forms";
import {BaseInfoBlock} from "@components/consumer/daily/giftGroups/forms";
import * as Yup from "yup";
import {toastr} from "@/utils/toastHelper";
import ConsumerDailyService from "@api/consumer/consumerDailyService";
import withPage from "@components/hoc/withPage";

interface AddGiftGroupFormValues {
    name: string;
    startTime: Date;
    endTime: Date;
    isActive: boolean;
}

const AddGiftGroupForm: FC = () => {

    const navigate = useNavigate();

    const initialValues: AddGiftGroupFormValues = {
        name: '',
        startTime: new Date(),
        endTime: new Date(),
        isActive: true
    }

    const validationSchema = Yup.object<AddGiftGroupFormValues>({
        name: Yup.string()
            .max(256, 'Название не должно превышать 256 символов')
            .required('Введите название'),
        startTime: Yup.date()
            .required('Выберите время начала'),
        endTime: Yup.date()
            .required('Выберите время окончания')
    });

    const onSubmit = useCallback(async (values: AddGiftGroupFormValues) => {
        const api = new ConsumerDailyService();
        const result = await api.putGiftGroup({
            name: values.name,
            startTime: values.startTime.toISOString(),
            endTime: values.endTime.toISOString(),
            isActive: values.isActive
        });

        if (result.success) {
            toastr.success("Создание группы", "Группа бонусов успешно создана");
            navigate(`/consumer/daily/groups/${result.data.id}/`, { replace: true });
        }
        else {
            toastr.error('Создание группы', 'Неизвестная ошибка');
        }
    }, [navigate]);

    return (
        <Formik
            initialValues={initialValues}
            onSubmit={onSubmit}
            validationSchema={validationSchema}
        >
            <Form>
                <Row className="g-3">
                    <Col xs={12}>
                        <FormPageHeader title="Создание группы бонусов" />
                    </Col>
                    <Col xs={12}>
                        <BaseInfoBlock />
                    </Col>
                    <Col>
                        <FormPageFooter
                            cancelUrl={'/consumer/daily/groups/'}
                        />
                    </Col>
                </Row>
            </Form>
        </Formik>
    )
}

export default withPage(AddGiftGroupForm);
